import { useSearchParams } from "react-router-dom";
import { Subtree } from "subtree.js/react";
import { pick } from "trunk.js";
import type { AppDeps } from "../../app-deps";
import { ShopQrController } from "./shop-qr-controller";
import { ShopQrPage } from "./shop-qr-page";

/** The customer served rides in the URL, for the tabs' links. */
export function ShopQrRoute({ deps }: { deps: AppDeps }) {
  const [params] = useSearchParams();
  const customerId = params.get("customer");
  return (
    <Subtree
      key="shop-qr"
      deps={[customerId]}
      controller={() =>
        new ShopQrController(
          pick(deps, "client", "authHandler", "storeRepository", "pendingCartsRepository"),
          customerId,
        )
      }
    >
      <ShopQrPage />
    </Subtree>
  );
}
